"use client";

import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ChevronUp } from "lucide-react";
import { useLocale } from "next-intl";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

const scrollToTopLabels: Record<string, string> = {
  pt: "Voltar ao topo",
  en: "Back to top",
  es: "Volver arriba",
  fr: "Retour en haut",
  it: "Torna in alto",
  de: "Nach oben",
  ro: "Înapoi sus",
};

export function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const locale = useLocale();
  const shouldReduceMotion = useReducedMotion();
  const ariaLabel = scrollToTopLabels[locale] ?? scrollToTopLabels.en;

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when page is scrolled down
      if (window.scrollY > 800) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: shouldReduceMotion ? "auto" : "smooth",
    });
  };

  const hiddenMotion = shouldReduceMotion
    ? { opacity: 0 }
    : { opacity: 0, scale: 0.5 };
  const visibleMotion = shouldReduceMotion
    ? { opacity: 1 }
    : { opacity: 1, scale: 1 };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed bottom-8 right-8 z-50"
          initial={hiddenMotion}
          animate={visibleMotion}
          exit={hiddenMotion}
          transition={{ duration: shouldReduceMotion ? 0 : 0.3 }}
        >
          <Button
            onClick={scrollToTop}
            size="icon"
            variant="default"
            className="h-10 w-10 rounded-full shadow-lg shadow-primary/20 backdrop-blur-sm bg-primary/90 hover:bg-primary"
            aria-label={ariaLabel}
          >
            <ChevronUp className="h-5 w-5" />
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
